import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { BarChart, Bar, XAxis, ResponsiveContainer } from "recharts";
import { RetentionModal } from "./retention-modal";
import { useState } from "react";

export function RetentionChart({
  retentionData,
  isLoading,
}: {
  retentionData: any;
  isLoading: boolean;
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  let results = retentionData?.data?.retentionData?.results;
  if (results) {
    results = [...results].reverse(); // Create new array and reverse
  }

  return (
    <>
      <Card
        className={cn(
          isLoading && "animate-pulse",
          "h-[292px] cursor-pointer transition-shadow hover:shadow-md",
        )}
        onClick={() => setIsModalOpen(true)}
      >
        <CardContent className="p-6">
          <div className="mb-4 flex items-center justify-between">
            <h3 className="font-['TWK Lausanne'] text-s font-normal leading-4 text-[#777]">
              Avg. Monthly Retention
            </h3>
          </div>
          <div className="font-['TWK Lausanne'] mb-4 text-3xl font-semibold leading-8 tracking-[-0.48px] text-black">
            {(
              parseFloat(retentionData?.data?.retentionData?.averageRetention) *
              100
            ).toFixed(0)}
            %
          </div>

          <div className="h-32">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={results}>
                <XAxis
                  dataKey="month"
                  axisLine={false}
                  tickLine={false}
                  tick={{ fontSize: 14 }}
                />
                <Bar
                  dataKey="activeTeens"
                  fill="#FF6B00"
                  radius={[0, 0, 4, 4]}
                  stackId="retention"
                />
                <Bar
                  dataKey="deactivatedTeens"
                  fill="#FFB693"
                  radius={[4, 4, 0, 0]}
                  stackId="retention"
                />
              </BarChart>
            </ResponsiveContainer>
          </div>

          <div className="font-['TWK Lausanne'] mt-3 flex items-center justify-center gap-4 text-xs">
            <div className="flex items-center gap-2">
              <div className="h-2 w-2 rounded-full bg-[#FF6B00]"></div>
              <span className="text-s font-normal leading-4 text-[#777]">
                Active
              </span>
            </div>
            <div className="flex items-center gap-2">
              <div className="h-2 w-2 rounded-full bg-[#FFB693]"></div>
              <span className="text-s font-normal leading-4 text-[#777]">
                De-activated
              </span>
            </div>
          </div>
        </CardContent>
      </Card>

      <RetentionModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        retentionData={retentionData}
      />
    </>
  );
}
